import DateRangeFilter from "@hydrologiq/shared/components/filters/DateRangeFilter"

interface CustomerPerformanceFiltersProps {
  startDate: string
  endDate: string
  onDateRangeChange: (start: string, end: string) => void
}

export default function CustomerPerformanceFilters({
  startDate,
  endDate,
  onDateRangeChange,
}: CustomerPerformanceFiltersProps) {
  return (
    <DateRangeFilter
      startDate={startDate}
      endDate={endDate}
      onDateRangeChange={onDateRangeChange}
      showIncludeFutureToggle={false}
    />
  )
}

